var _rect, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPriorityLow(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.00022,
    height: 16.0006,
    rx: 0.915344,
    transform: "matrix(-1 0 0 1 18 2)",
    fill: "#DEE2E9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4.00022,
    height: 12.0005,
    rx: 0.915344,
    transform: "matrix(-1 0 0 1 12 6)",
    fill: "#DEE2E9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.00022,
    height: 8.00031,
    rx: 0.915344,
    transform: "matrix(-1 0 0 1 6 10)",
    fill: "#676879"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityLow);
export default __webpack_public_path__ + "static/media/priority-low.6a1367e0.svg";
export { ForwardRef as ReactComponent };